import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { createBaseLayer, QUEBEC_CENTER } from '@/lib/map';
import { groupMarkerIcon, reportMarkerIcon } from '@/lib/map-markers';
import { STATUS_COLORS } from '@/lib/report-colors';
/** Aperçu d'une limite municipale (GeoJSON) et, facultativement, de points. */
export function BoundaryMap({ geojson, points = [], className, onPointClick, }) {
    const ref = useRef(null);
    const mapRef = useRef(null);
    const layerRef = useRef(null);
    useEffect(() => {
        if (!ref.current || mapRef.current)
            return;
        const map = L.map(ref.current, { zoomControl: true, attributionControl: false }).setView(QUEBEC_CENTER, 6);
        createBaseLayer().addTo(map);
        layerRef.current = L.layerGroup().addTo(map);
        mapRef.current = map;
        const ro = new ResizeObserver(() => map.invalidateSize());
        ro.observe(ref.current);
        return () => {
            ro.disconnect();
            map.remove();
            mapRef.current = null;
        };
    }, []);
    useEffect(() => {
        const map = mapRef.current;
        const layer = layerRef.current;
        if (!map || !layer)
            return;
        layer.clearLayers();
        let bounds = null;
        if (geojson) {
            const g = L.geoJSON(geojson, { style: { color: '#298FC2', weight: 2, fillOpacity: 0.12 } }).addTo(layer);
            bounds = g.getBounds();
        }
        for (const p of points) {
            const icon = p.count != null ? groupMarkerIcon(p.count) : reportMarkerIcon({ color: p.color ?? STATUS_COLORS.OPEN, iconName: p.iconName });
            const marker = L.marker([p.latitude, p.longitude], { icon })
                .bindTooltip(p.label ?? '')
                .addTo(layer);
            if (p.id && onPointClick)
                marker.on('click', () => onPointClick(p.id));
            bounds = bounds ? bounds.extend([p.latitude, p.longitude]) : L.latLngBounds([[p.latitude, p.longitude], [p.latitude, p.longitude]]);
        }
        if (bounds?.isValid())
            map.fitBounds(bounds, { padding: [20, 20], maxZoom: 12 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [geojson, JSON.stringify(points)]);
    return _jsx("div", { ref: ref, className: className });
}
//# sourceMappingURL=BoundaryMap.js.map